import React, { useEffect, useState } from "react";
import { appConfigs, fileIcon, formatFileSize, toAbsoluteUrl } from "../../_helpers";
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import axios from "axios";
import { shallowEqual, useSelector } from "react-redux";

export function FilePreviewer({ title = '', description = '', url, deletingStatus, deleted, alert }) {
    const [icon, setIcon] = useState('');
    const [size, setSize] = useState('');
    const [deleting, setDeleting] = useState(false);
    const { authToken } = useSelector(
        (state) => ({
            authToken: state.auth.authToken,
        }),
        shallowEqual
    );
    const deleteFile = () => {
        alert(null);
        deletingStatus(true);
        setDeleting(true);
        const data = {
            file: url.split('\\').pop().split('/').pop(),
            jwt: authToken,
        };
        axios.post(appConfigs.api_url + 'delete-file', { data }).then(res => {
            if (res.data.response_code === 1) {
                alert({ type: 'success', msg: `The file was deleted successfully` });
                deletingStatus(false);
                setDeleting(false);
                deleted(true);
            } else {
                alert({ type: 'error', msg: res.data.description || 'A critical error occurred while deleting the file, please try again.' });
                deletingStatus(false);
                setDeleting(false);
                deleted(true);
            };
        }).catch(err => {
            alert({ type: 'error', msg: err || 'A critical error occurred, please try again.' });
            deletingStatus(false);
            setDeleting(false);
        });
    };
    useEffect(() => {
        const extRegex = /(?:\.([^.]+))?$/;
        const ext = extRegex.exec(url)[1];
        setIcon(fileIcon(ext));
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "arraybuffer";
        xhr.onreadystatechange = function () {
            if (this.readyState === this.DONE) setSize(formatFileSize(this.response.byteLength));
        };
        xhr.send(null);
    }, [url]);

    return (
        <>
            {(title !== '') && <p style={{ marginBottom: '4px', color: 'var(--mn-text-50)', fontSize: '1rem' }}>{title}</p>}
            <div className="file-preview">
                <div className="file-img"><img src={toAbsoluteUrl(icon)} alt="icon" /></div>
                <div className="file-description">
                    <small>{url}</small>
                    <small>{(size !== '') && <span>{size}</span>}<a href={url} target="_blank" rel="noreferrer">Show preview</a></small>
                </div>
                <div className="file-remove">
                    <IconButton color="default" size="small" onClick={() => deleteFile()}><Close /></IconButton>
                </div>
                {deleting && <div className="file-removing">
                    <CircularProgress color="secondary" size="1.75rem" />
                </div>}
            </div>
            {(description !== '') && <p style={{ marginTop: '10px', marginBottom: '12px', color: 'var(--mn-text-50)', fontSize: '0.75rem', lineHeight: '1' }}>{description}</p>}
        </>
    );
}
